import React from 'react';
import { EditorView } from '@codemirror/view';
export const useEditorClasses = (compartment, editor, classNamesContent) => {
  React.useEffect(() => {
    if (!editor || !classNamesContent || classNamesContent.length === 0) return;
    editor.dispatch({
      effects: compartment.reconfigure(EditorView.editorAttributes.of({
        class: classNamesContent.join(' ')
      }))
    });
    return () => editor.dispatch({
      effects: compartment.reconfigure(EditorView.editorAttributes.of({
        class: ''
      }))
    });
  }, [compartment, editor, classNamesContent]);
};